module.exports = __webpack_public_path__ + "img/currents.813361a.png";